import { forwardRef, type Ref, type SVGProps } from "react";
const IconMicrophoneFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M11.27 14.47a4.72 4.72 0 0 0 9.44 0V6.69a4.72 4.72 0 0 0-9.44 0z" />
    <path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 1 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41" />
    <path d="M11 14.47a4.83 4.83 0 0 0 5 4.67 4.85 4.85 0 0 0 5-4.67V6.69A4.85 4.85 0 0 0 16 2a4.83 4.83 0 0 0-5 4.66z" />
    <path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 1 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41" />
  </svg>
);
const ForwardRef = forwardRef(IconMicrophoneFilledSVG);
ForwardRef.displayName = "IconMicrophoneFilled";
export { ForwardRef as IconMicrophoneFilled };
